module.exports = __webpack_public_path__ + "assets/snow.f380b4c9.svg";